import PropTypes from "prop-types"
import { Link } from "react-router-dom"

import Shimmer from "components/ui/shimmer"
import { cn } from "styles/utils"

const Breadcrumb = ({ article, isLoading }) => {
  return (
    <nav aria-label="Breadcrumb">
      <ol className="text-14 tablet:overflow-x-hidden text-grey-500 mb-16 mt-24 list-none overflow-x-auto whitespace-nowrap pb-8 font-light leading-none">
        <li className="inline-flex after:px-4 after:content-['/']">
          <Link data-lc="breadcrumb" to="/">
            Home
          </Link>
        </li>
        <li
          className={cn(
            "inline-flex",
            (article || isLoading) && "after:px-4 after:content-['/']"
          )}
        >
          {article ? (
            <Link data-lc="breadcrumb" to="/blog">
              {sl.config.site_title} Blog
            </Link>
          ) : (
            <>{sl.config.site_title} Blog</>
          )}
        </li>
        {isLoading ? (
          <li className="inline-flex">
            <Shimmer
              className="inline-block"
              style={{ height: "14px", width: "360px" }}
            />
          </li>
        ) : (
          article && <li className="inline-flex">{article}</li>
        )}
      </ol>
    </nav>
  )
}

Breadcrumb.propTypes = {
  article: PropTypes.string,
  isLoading: PropTypes.bool,
}

export default Breadcrumb
